import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_vzcwf2s2c8: FaireBrandEntity = {
  token: "b_vzcwf2s2c8",
  type: "brand",
  name: "alberalkirk",
  avatarUrl:
    "https://cdn.faire.com/fastly/6fc49498bfda1dafbcf6946adcac38e7895d3644fd5d7214c87ef3fa8fe382ac.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/d991b67776be3a0e38f606f483ad96bc826428a1185d32cd6e4ba5b87c59bcae.png",
  logoUrl:
    "https://cdn.faire.com/fastly/6fc49498bfda1dafbcf6946adcac38e7895d3644fd5d7214c87ef3fa8fe382ac.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d991b67776be3a0e38f606f483ad96bc826428a1185d32cd6e4ba5b87c59bcae.png",
  location: "Lexington, KY, USA",
  minimumOrderDollars: 100,
  rating: 4.6,
  reviewCount: 26,
  isInsider: true,
  description:
    "✅ Trend-forward styles, updated weekly\n✅ Low MOQs & fast fulfillment\n✅ Free shipping available\n\nBold. Feminine. Effortlessly Confident.\nAlberalkirk offers boutique-ready clothing, bags, and accessories infused with vintage charm, bold sexiness, and vibrant colors. With a focus on retro-inspired yet wearable designs, we empower women to express their individuality with ease and confidence—no matter the occasion.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:37.793Z",
    importedBy: "entity-db-cli",
  },
};
